import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  "xml:space": "preserve"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M20.04 9.64c-.79 0-1.44.64-1.44 1.42v13.15c0 .79.64 1.42 1.44 1.42.79 0 1.44-.64 1.44-1.42V11.07c0-.79-.64-1.43-1.44-1.43zM23.39 11.82h-.42c-.68 0-1.22.54-1.22 1.21v9.23c0 .67.55 1.21 1.22 1.21h.42c.68 0 1.22-.54 1.22-1.21v-9.23c0-.67-.55-1.21-1.22-1.21zM11.82 16.4h6.67v2.49h-6.67zM25.8 16.4h-1.04v2.49h1.04c.68 0 1.22-.54 1.22-1.21v-.06c0-.68-.55-1.22-1.22-1.22zM10.13 9.64c-.79 0-1.44.64-1.44 1.42v13.15c0 .79.64 1.42 1.44 1.42.79 0 1.44-.64 1.44-1.42V11.07c0-.79-.64-1.43-1.44-1.43zM7.21 11.81h-.42c-.68 0-1.22.54-1.22 1.21v9.23c0 .67.55 1.21 1.22 1.21h.42c.68 0 1.22-.54 1.22-1.21v-9.23c.01-.66-.54-1.21-1.22-1.21zM3.02 17.67v-.06c0-.71.55-1.29 1.24-1.29h1.05v2.64H4.26c-.69 0-1.24-.58-1.24-1.29" })
    ], -1)
  ])))
}
export default { render };